import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import { deleteCaseSuccess, deleteCaseFailure, OFLC_DELETE_CASE } from '../actions';

import util from '../../../global/utils/Helpers';
import 'isomorphic-fetch';
import { polyfill } from 'es6-promise';
polyfill();

let apiIndex = util.isLocalhost()
	? 'http://localhost:9393/auth/visa/delete/'
	: `${util.getCurrentHost()}/auth/auth/visa/delete/`;

const fetchDeleteCase = (action$) =>
	action$.pipe(
		ofType(OFLC_DELETE_CASE),
		mergeMap((action) =>
			fetch(apiIndex + action.payload.form_id, {
				credentials: 'include',
				method: 'POST',
				body: JSON.stringify(action.payload),
				headers: {
					'Content-Type': 'application/json',
					Authorization: 'Basic ' + window.btoa('flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1')
				}
			})
				.then((response) => {
					if (response.statusCode === 400) {
						return deleteCaseFailure();
					} else if (response.status === 204) {
						return deleteCaseSuccess(action.payload);
					} else {
						return deleteCaseFailure();
					}
				})
				.catch((error) => deleteCaseFailure())
		)
	);

export default fetchDeleteCase;
